<template>
	<div>
		<div id="gerarPoligono" />

		<VueHtml2pdf
			ref="html2Pdf"
			:show-layout="false"
			:float-layout="true"
			:enable-download="true"
			:preview-modal="true"
			:paginate-elements-by-height="1400"
			:filename="$t('report')"
			:pdf-quality="2"
			:manual-pagination="true"
			pdf-format="a4"
			pdf-orientation="portrait"
			pdf-content-width="790px"
		>
			<section
				slot="pdf-content"
				style="margin: 8px"
			>
				<section
					class="pdf-item"
					style="display: flex; justify-content: space-between; flex-direction: column"
				>
					<label style="text-align: center"
						>RESULTADO DO INVENTÁRIO FLORESTAL RESUMO EXECUTIVO</label
					>
					<div
						v-if="Object.keys(dadosRelatorio).length > 0"
						style="
							display: flex;
							flex-direction: row-reverse;
							justify-content: space-between;
							background-color: var(--color-background);
							padding: 1rem;
							border-radius: 5px;
						"
					>
						<div>
							<p style="display: flex; flex-direction: column; text-align: end">
								<strong style="font-size: 0.8rem">{{ $t('forestInventory') }}:</strong
								>{{ dadosGerais.codigoProcessamento || $t('notInformed') }}
							</p>
							<p style="display: flex; flex-direction: column; text-align: end">
								<strong style="font-size: 0.8rem">{{ $t('measurementPeriod') }}:</strong>
								{{ dadosGerais.periodo || $t('notInformed') }}
							</p>
							<p style="display: flex; flex-direction: column; text-align: end">
								<strong style="font-size: 0.8rem">{{ $t('reportExpedition') }}:</strong>
								{{ dadosGerais.expedicao || $t('notInformed') }}
							</p>
							<p style="display: flex; flex-direction: column; text-align: end">
								<strong style="font-size: 0.8rem">{{ $t('user') }}:</strong>
								{{ dadosGerais.usuario || $t('notInformed') }}
							</p>
							<p style="display: flex; flex-direction: column; text-align: end">
								<strong style="font-size: 0.8rem">{{ $t('owner') }}:</strong>
								{{ dadosGerais.proprietario || $t('notInformed') }}
							</p>
						</div>
						<div>
							<p style="display: flex; flex-direction: column">
								<strong style="font-size: 0.8rem">{{ $t('farm') }}:</strong
								>{{ dadosGerais.fazenda || $t('notInformed') }}
							</p>
							<p style="display: flex; flex-direction: column">
								<strong style="font-size: 0.8rem">{{ $t('farmArea') }}:</strong>
								{{ dadosGerais.areaFazenda || $t('notInformed') }} ha
							</p>
							<p style="display: flex; flex-direction: column">
								<strong style="font-size: 0.8rem">{{ $t('effectivePlantingArea') }}:</strong>
								{{ dadosGerais.areaEfetivoPlantio || $t('notInformed') }} ha
							</p>
							<p style="display: flex; flex-direction: column">
								<strong style="font-size: 0.8rem">{{ $t('city') }}:</strong>
								{{ dadosGerais.cidade || $t('notInformed') }}
							</p>
							<p style="display: flex; flex-direction: column">
								<strong style="font-size: 0.8rem">{{ $t('state') }}:</strong>
								{{ dadosGerais.estado || $t('notInformed') }}
							</p>
						</div>
					</div>
					<div style="height: 100%; display: flex; justify-items: center; justify-content: center">
						<GraficoCategoriaDeArvore
							report-mode
							style="padding: 0"
							:data="categoriaArvore"
							subtitle=""
						/>
					</div>
				</section>

				<div class="html2pdf__page-break" />

				<section
					style="margin-top: 1rem"
					class="pdf-item"
				>
					<!-- <hr /> -->
					<GraficoArvoresUteis
						report-mode
						style="padding: 0"
						:data="proporcaoFustes"
						subtitle=""
					/>

					<!-- </div> -->

					<GraficoArvoresUteisPorPlantio
						report-mode
						style="padding: 0; margin-top: 1rem"
						:data="indicePerda"
						subtitle=""
					/>
					<div class="html2pdf__page-break" />

					<GraficoIMA
						v-show="Object.keys(dadosIMA).length != 0"
						style="padding: 0; margin-top: 1rem"
						:data="dadosIMA"
						subtitle=""
					/>
					<div v-if="dadosSortimento.length">
						<label style="color: rgb(var(--color-primary)); font-weight: 700; text-align: center"
							>RESULTADOS DO SORTIMENTO</label
						>

						<div
							v-for="produto in sortimento"
							:key="produto.produto"
						>
							<label style="color: rgb(var(--color-primary)); font-weight: 700; margin-top: 1rem">{{
								produto.produto
							}}</label>
							<NormalTable
								style="max-width: 100%"
								report-mode
								:headers="headersSortimento"
								:data="produto.dado"
							/>
						</div>
					</div>
				</section>

				<div class="html2pdf__page-break" />

				<section
					style="margin-top: 1rem"
					class="pdf-item"
				>
					<label style="color: rgb(var(--color-primary)); font-weight: 700"
						>VTCC - Volume Total com Casca (m³/ha)</label
					>
					<NormalTable
						style="max-width: 100%"
						report-mode
						:headers="headers"
						:data="vtcc"
					/>
					<br />
					<br />
					<label style="color: rgb(var(--color-primary)); font-weight: 700"
						>VTSC - Volume Total sem Casca (m³/ha)</label
					>
					<NormalTable
						style="max-width: 100%"
						report-mode
						:headers="headers"
						:data="vtsc"
					/>
				</section>
				<div class="html2pdf__page-break" />

				<section
					class="pdf-item"
					style="margin-top: 1rem"
				>
					<label style="color: rgb(var(--color-primary)); font-weight: 700">{{ $t('map') }}</label>
					<DashBoardCardMap
						ref="ref__cardmap"
						style="border-radius: 10px"
					/>
					<div
						style="
							display: flex;
							gap: 1rem;
							flex-wrap: wrap;
							justify-content: center;
							padding: 1rem;
						"
					>
						<div
							v-for="talhao in volumePorTalhao"
							:key="talhao.talhao"
							style="
								background-color: white;
								width: fit-content;
								padding: 0.8rem;
								border-radius: 5px;
								min-width: 150px;
							"
						>
							<p style="margin: 0; text-align: center">
								{{ talhao.talhao }}
							</p>
							<div style="width: 100%; justify-content: space-between; padding: 1.5rem 0">
								<PoligonoSvg
									style="height: 4rem; text-align: center"
									:info-geo="{
										poligono: getGeoJsonPtio.features.find(
											(f) => f.properties['Codigo Talhao'] === talhao.talhao,
										),
									}"
								/>
							</div>
							<div style="display: flex; justify-content: space-between">
								<div>
									<p style="margin: 0; text-align: start">VTCC</p>
									<p style="margin: 0; text-align: end; font-size: 0.8rem">
										{{ talhao.vtccMedio.toFixed(3) }}
									</p>
								</div>
								<div>
									<p style="margin: 0; text-align: end">VTSC</p>
									<p style="margin: 0; text-align: end; font-size: 0.8rem">
										{{ talhao.vtscMedio.toFixed(3) }}
									</p>
								</div>
							</div>
						</div>
					</div>
				</section>

				<!-- PDF Content Here -->
			</section>
		</VueHtml2pdf>
		<Button
			:disabled="Object.values(dadosRelatorio).length === 0"
			:label="$t('generate')"
			@click="generateReport"
		/>
	</div>
</template>

<script>
import { mapActions } from 'vuex'

import ControllingPaginationMixins from '../../../mixins/ControllingPaginationMixins'
import RegistersMixins from '../../../mixins/RegistersMixins'
import { getAllFazendasComInventarioFlorestalDropdown } from '../../../services/requests/FazendaRequests'

import DashBoardCardMap from '../../Dashboard/CardMap/DashBoardCardMap'

import GraficoCategoriaDeArvore from '../../Dashboard/CardGrafico/Graficos/GraficoCategoriaDeArvore'
import GraficoArvoresUteis from '../../Dashboard/CardGrafico/Graficos/GraficoArvoresUteis'
import GraficoArvoresUteisPorPlantio from '../../Dashboard/CardGrafico/Graficos/GraficoArvoresUteisPorPlantio'
import NormalTable from '../../../components/CrudTable/NormalTable/NormalTable.vue'
import PoligonoSvg from '../../../components/PoligonoSvg/PoligonoSvg.vue'
import GraficoIMA from '../../../components/Graficos/GraficoIMA.vue'

import Button from '../../../components/Button/Button.vue'

// import chroma from "chroma-js";
import axios from 'axios'

import {
	dadosDeSortimento,
	dadosDeImaHistorico,
	dadosParaRelatorio,
} from '../../../services/requests/RelatorioRequests'
import { getAllInventarioFlorestal } from '../../../services/requests/InventarioFlorestalRequests'
import { getAllMedicoesInventario } from '../../../services/requests/MedicoesInventarioRequests'

import {
	getInventarioPlantioGroupedByMaterialGeneticoEqualsFazendaId,
	getInventarioPlantioGroupedByFaixaDeIdadeEqualsFazendaId,
	getDataUltimoProcessamentoByFazendaId,
} from '../../../services/requests/DashBoardRequests'

import { mapGetters } from 'vuex'

import { CoordenatesToGooglePattern } from '../../../utils/MapFunctions'

import VueHtml2pdf from 'vue-html2pdf'

export default {
	name: 'RelatorioInventarioFlorestal',
	components: {
		PoligonoSvg,
		Button,
		GraficoIMA,
		VueHtml2pdf,
		DashBoardCardMap,
		GraficoCategoriaDeArvore,
		GraficoArvoresUteis,
		GraficoArvoresUteisPorPlantio,
		NormalTable,
	},
	computed: {
		...mapGetters('moduleImportShape', ['getGeoJsonPtio']),

		sortimento() {
			return this.dadosSortimento.map(({ produto, plantios }) => {
				const dado = plantios.map(({ sortimentoQuantidadePlantios, plantio, areaEfetiva }) => {
					sortimentoQuantidadePlantios.codigo = plantio
					sortimentoQuantidadePlantios.area = areaEfetiva

					return sortimentoQuantidadePlantios
				})

				dado.push({
					codigo: this.$t('forestStratification'),
					area: dado
						.map((m) => m.area)
						.reduce((a, b) => a + b, 0)
						.toFixed(2),
					li: dado
						.map((m) => m.li)
						.reduce((a, b) => a + b, 0)
						.toFixed(2),
					ls: dado
						.map((m) => m.ls)
						.reduce((a, b) => a + b, 0)
						.toFixed(2),
					media: dado
						.map((m) => m.media)
						.reduce((a, b) => a + b, 0)
						.toFixed(2),
					ns: dado[0].ns,
					proporcao: dado
						.map((m) => m.proporcao)
						.reduce((a, b) => a + b, 0)
						.toFixed(2),
					un: dado
						.map((m) => m.un)
						.reduce((a, b) => a + b, 0)
						.toFixed(2),
				})

				return { produto, dado }
			})
		},
		volumePorTalhao() {
			// const cores = chroma
			//   .scale(["#fafa6e", "#2A4858"])
			//   .mode("lch")
			//   .colors(this.dadosRelatorio.dadosRelatorio.volumePorTalhao.length);

			return this.dadosRelatorio.dadosRelatorio
				? this.dadosRelatorio.dadosRelatorio.volumePorTalhao
				: []
		},
		vtsc() {
			const linhas = []
			const vtsc = this.dadosRelatorio.dadosRelatorio?.nivelPovoamento.vtsc

			if (vtsc) {
				const { estrato, talhoes } = vtsc
				estrato.area = talhoes
					.map((talhao) => talhao.area)
					.reduce((a, b) => a + b, 0)
					.toFixed(2)
				estrato.codigo = 'Estrato'
				estrato.total = (estrato.area * estrato.media).toFixed(4)
				estrato.totalli = (estrato.area * estrato.li).toFixed(4)
				estrato.totalls = (estrato.area * estrato.ls).toFixed(4)
				estrato.totalun = (estrato.area * estrato.un).toFixed(4)

				linhas.push(estrato)
				talhoes.forEach((talhao) => {
					talhao.total = (talhao.area * talhao.media).toFixed(4)
					talhao.totalli = (talhao.area * talhao.li).toFixed(4)
					talhao.totalls = (talhao.area * talhao.ls).toFixed(4)
					talhao.totalun = (talhao.area * talhao.un).toFixed(4)

					linhas.push(talhao)
				})
			}

			return linhas
		},
		vtcc() {
			const linhas = []
			const vtcc = this.dadosRelatorio.dadosRelatorio?.nivelPovoamento.vtcc

			if (vtcc) {
				const { estrato, talhoes } = vtcc
				estrato.area = talhoes
					.map((talhao) => talhao.area)
					.reduce((a, b) => a + b, 0)
					.toFixed(2)
				estrato.codigo = 'Estrato'
				estrato.total = (estrato.area * estrato.media).toFixed(4)
				estrato.totalli = (estrato.area * estrato.li).toFixed(4)
				estrato.totalls = (estrato.area * estrato.ls).toFixed(4)
				estrato.totalun = (estrato.area * estrato.un).toFixed(4)

				linhas.push(estrato)
				talhoes.forEach((talhao) => {
					talhao.total = (talhao.area * talhao.media).toFixed(4)
					talhao.totalli = (talhao.area * talhao.li).toFixed(4)
					talhao.totalls = (talhao.area * talhao.ls).toFixed(4)
					talhao.totalun = (talhao.area * talhao.un).toFixed(4)

					linhas.push(talhao)
				})
			}

			return linhas
		},
		headers() {
			return [
				{
					key: 'codigo',
					value: 'Código',
					isActive: true,
				},
				{
					key: 'area',
					value: 'Área (ha)',
					isActive: true,
				},
				{
					key: 'media',
					value: 'Média (m3/ha)',
					isActive: true,
				},
				{
					key: 'li',
					value: 'IC.LI (m3/ha)',
					isActive: true,
				},
				{
					key: 'ls',
					value: 'IC.LS (m3/ha)',
					isActive: true,
				},
				{
					key: 'un',
					value: 'IC.UN (m3/ha)',
					isActive: true,
				},
				{
					key: 'total',
					value: 'Total (m3)',
					isActive: true,
				},
				{
					key: 'totalli',
					value: 'IC.LI (m3)',
					isActive: true,
				},
				{
					key: 'totalls',
					value: 'IC.LS (m3)',
					isActive: true,
				},
				{
					key: 'totalun',
					value: 'IC.UN (m3)',
					isActive: true,
				},
				{
					key: 'proporcao',
					value: 'IC.P (%)',
					isActive: true,
				},
				{
					key: 'ns',
					value: 'IC.NS (%)',
					isActive: true,
				},
			]
		},
		headersSortimento() {
			return [
				{
					key: 'codigo',
					value: 'Código',
					isActive: true,
				},
				{
					key: 'area',
					value: 'Área (ha)',
					isActive: true,
				},
				{
					key: 'media',
					value: 'Média (m3/ha)',
					isActive: true,
				},
				{
					key: 'li',
					value: 'IC.LI (m3/ha)',
					isActive: true,
				},
				{
					key: 'ls',
					value: 'IC.LS (m3/ha)',
					isActive: true,
				},
				{
					key: 'un',
					value: 'IC.UN (m3/ha)',
					isActive: true,
				},
				{
					key: 'proporcao',
					value: 'IC.P (%)',
					isActive: true,
				},
				{
					key: 'ns',
					value: 'IC.NS (%)',
					isActive: true,
				},
			]
		},
		indicePerda() {
			return this.dadosRelatorio.dadosRelatorio
				? this.dadosRelatorio.dadosRelatorio.indicePerda.map((m) => {
						return {
							codigoDoPlantio: m.tlho_cd_codigo,
							proporcaoArvoreUtil: m.uteis,
							totalDeArvoresNaoUteis: m.naoUteis,
						}
					})
				: []
		},
		proporcaoFustes() {
			return {
				totalDeArvoresNaoUteis: this.dadosRelatorio.dadosRelatorio
					? this.dadosRelatorio.dadosRelatorio.proporcaoFustes.naoUteis
					: 0,
				totalDeArvoresUteis: this.dadosRelatorio.dadosRelatorio
					? this.dadosRelatorio.dadosRelatorio.proporcaoFustes.uteis
					: 0,
			}
		},
		/**
		 * Dados do gráfico de categoria de árvore.
		 *
		 * As chaves precisam ser as que o GraficoCategoriaDeArvore consome:
		 * `quantidadeTotal` (não `quantidade`, que deixava o eixo sem valor) e
		 * `cor`, para o gráfico usar a cor cadastrada em vez de derivá-la do nome.
		 */
		categoriaArvore() {
			return (
				this.dadosRelatorio.dadosRelatorio?.proporcaoTipoArvore.map((m) => {
					return {
						categoriaDeArvore: m.nomeCategoria,
						quantidadeTotal: m.proporcao,
						cor: m.cor,
					}
				}) || []
			)
		},
		dadosGerais() {
			return {
				codigoProcessamento: this.dadosRelatorio.cadastro?.processamento?.codigo,
				periodo: new Date(
					this.dadosRelatorio.cadastro?.processamento?.periodoMedicao,
				).toLocaleDateString(),
				usuario: this.dadosRelatorio.usuario,
				expedicao: new Date(this.dadosRelatorio.dataExpedicao).toLocaleDateString(),
				fazenda: this.dadosRelatorio.cadastro?.fazenda.nome,
				proprietario: this.dadosRelatorio.cadastro?.fazenda.proprietario,
				areaFazenda: this.dadosRelatorio.cadastro?.fazenda.area,
				areaEfetivoPlantio: this.dadosRelatorio.cadastro?.fazenda.areaEfetivoPlantio,
				cidade: this.dadosRelatorio.cadastro?.fazenda.cidade,
				estado: this.dadosRelatorio.cadastro?.fazenda.uf,
			}
		},

		inventarioFlorestal() {
			return this.nomeInventario.map((m) => {
				return {
					label: m[0],
					value: m[1],
				}
			})
		},
	},

	data() {
		return {
			dataGraficoArvoresUteisPorPlantio: [],
			fazenda: [],
			sourceCancelToken: {},
			dadosRelatorio: {},
			dadosIMA: {},
			dadosSortimento: [],
			// Controle de exibicao dos graficos
			model: {
				fzda_ds_descricao: '',
				fk_eicb_estrato_invcbg: '',
				// inventarioFlorestalId: "c6d433b6-dbdb-4c54-874f-0333acd23ac6",
				inventarioFlorestalId: '',
				inventarioFlorestalId2: '',
			},
		}
	},
	methods: {
		generateReport() {
			this.$refs.html2Pdf.generatePdf()
		},

		...mapActions('moduleImportShape', ['setAllShapes']),

		/**
		 * Seta o id da fazenda
		 */
		setFazendaId(fazendaId) {
			this.fazendaId = fazendaId
		},
		/**
		 * Seta os valores iniciais para cada mapInfo
		 */
		setInitialValueToMapInfo(mapInfos) {
			mapInfos.forEach((mapInfo) => {
				mapInfo.mapInfoPoligono = {}
				mapInfo.isActived = false
			})
			this.dataCardMap = mapInfos
		},

		/**
		 * Junta as informacoes de duas requisicoes diferentes
		 * Requisicao 1 = Informações da fazenda / estrato
		 * Requisicao 2 = Poligonos
		 */
		mergePoligonosToMapInfo() {
			if (this.dataCardMap.length > 0 && this.mapInfoPoligonos.poligonos) {
				const { poligonos, bounds } = this.mapInfoPoligonos

				this.dataCardMap.forEach((mapInfo) => {
					const mapInfoPoligono = poligonos.find(
						(mapInfoPoligono) => mapInfoPoligono.id === mapInfo.id,
					)
					if (mapInfoPoligono) {
						mapInfoPoligono.paths = CoordenatesToGooglePattern(
							mapInfoPoligono.poligono.coordinates,
							mapInfoPoligono.poligono.type,
						)
						mapInfo.mapInfoPoligono = mapInfoPoligono
					}
				})

				const [west, south, east, north] = bounds
				this.boundsAllPoligonos = { east, north, south, west }
			}
		},

		/**
		 * Seta os dados dos cards
		 */
		setDashboardInfoFazenda(dashboardInfoFazendas) {
			this.setInitialValueToMapInfo(dashboardInfoFazendas.cardMapInfos)
			this.mergePoligonosToMapInfo()
		},

		/**
		 * Troca o nome da fazenda atual, atualizando o titulo do dashboard
		 */
		trocarNomeDaFazenda(idDaFazenda) {
			if (idDaFazenda === '') this.nomeDaFazendaAtual = ''
			else {
				this.nomeDaFazendaAtual = this.fazendas.find(
					(fazenda) => fazenda.value === idDaFazenda,
				).label
			}
		},

		/**
		 * Retorna os dados de uma fazenda selecionar no dropdown de fazendas
		 */

		getDashboardFazenda(fazendaId) {
			this.$store.dispatch('moduleDashboardCardInfo/apiCardInfoFazenda', fazendaId)

			this.trocarNomeDaFazenda(fazendaId)

			getDataUltimoProcessamentoByFazendaId(fazendaId, this.sourceCancelToken.token).then(
				(response) => {
					this.dataUltimoProcessamento = new Date(response.data.result)
				},
			)

			getInventarioPlantioGroupedByMaterialGeneticoEqualsFazendaId(
				fazendaId,
				this.sourceCancelToken.token,
			).then((response) => {
				this.dataGraficoMaterialGenetico = response.data.result
			})

			getInventarioPlantioGroupedByFaixaDeIdadeEqualsFazendaId(
				fazendaId,
				this.sourceCancelToken.token,
			).then((response) => {
				this.dataGraficoFaixaDeIdade = response.data.result
			})
		},

		/**
		 * Faz as requisicoes necessarias para recuperar os dados de todas as fazendas
		 */
		getDashboardGeral() {
			this.$store.dispatch('moduleDashboardCardInfo/apiCardInfoGeral')

			this.trocarNomeDaFazenda('')
		},
	},
	watch: {
		/**
		 * Sempre que o valor de ID da fazenda alterar,
		 */
		'model.fzda_ds_descricao': function (fazendaId) {
			console.log('fazendaId', fazendaId)

			this.arrayMedicao.forEach((m) => {
				if (m.fk_fzda_fazenda == fazendaId) {
					this.fazenda.fkMedicao = m.id
				}
			})
			console.log(
				'this.fazenda.fkMedicaothis.fazenda.fkMedicaothis.fazenda.fkMedicao',
				this.fazenda.fkMedicao,
			)

			console.log('this.nomeInventariothis.nomeInventario', this.nomeInventario)
		},
	},
	/**
	 * Carrega todos os dados relacionados as fazendas cadastradas
	 */
	mixins: [ControllingPaginationMixins, RegistersMixins],

	async created() {
		this.sourceCancelToken = axios.CancelToken.source()
		dadosParaRelatorio(
			'c3705dfd-46c9-4299-af9a-690d7b4b0f95', //inventarioFlorestalId
			this.sourceCancelToken.token,
		).then((response) => {
			this.dadosRelatorio = response.data.result
			const { fazenda, plantios, talhoes } = this.dadosRelatorio.dadosRelatorio.mapa
			this.setAllShapes({
				fazenda: JSON.parse(fazenda),
				talhoes: JSON.parse(talhoes),
				plantios: JSON.parse(plantios),
			})
		})

		dadosDeImaHistorico('c3705dfd-46c9-4299-af9a-690d7b4b0f95', this.sourceCancelToken.token).then(
			(response) => {
				this.dadosIMA = response.data.result
				console.log(
					'🚀 ~ file: RelatorioInventarioFlorestalPocket.vue ~ line 450 ~ dadosDeImaHistorico ~ response',
					response,
				)
			},
		)

		dadosDeSortimento('c3705dfd-46c9-4299-af9a-690d7b4b0f95', this.sourceCancelToken.token).then(
			(response) => {
				this.dadosSortimento = response.data.result
				console.log(
					'🚀 ~ file: RelatorioInventarioFlorestalPocket.vue ~ line 443 ~ dadosDeSortimento ~ response',
					response.data.result,
				)
			},
		)
		;(getAllMedicoesInventario().then((response) => {
			var { result: medicao } = response.data
			console.log(
				'🚀 ~ file: RelatorioInventarioFlorestal.vue ~ line 712 ~ getAllMedicoesInventario ~ medicao',
				medicao,
			)
			this.arrayMedicao = medicao
		}),
			(this.quantityPerPage = 10))

		getAllInventarioFlorestal().then((response) => {
			var { result: inventarios } = response.data
			console.log('inventarioFLROESTAL', response.data)

			this.inventario = inventarios
			this.model.fk_eicb_estrato_invcbg = inventarios[0].fk_eicb_estrato_invcbg
			console.log('cubagem', this.model.fk_eicb_estrato_invcbg)
			console.log('nomeinv2', this.inventario)
		})

		getAllFazendasComInventarioFlorestalDropdown().then((response) => {
			const fazendas = response
			console.log(
				'🚀 ~ file: InventarioFlorestal.vue ~ line 187 ~ getDropdownFazendas ~ fazendas',
				fazendas,
			)

			this.fazenda = fazendas
			console.log(
				'🚀 ~ file: RelatorioInventarioFlorestal.vue ~ line 715 ~ getDropdownFazendas ~ this.fazenda',
				this.fazenda,
			)
		})
	},
}
</script>

<style scoped>
/* @import url("../../../css/inventoryReportPrint.css"); */

p {
	margin: 0;
}

.container__dashboard {
	width: 100%;
	height: 100%;
}

.container__dashboard__kpis {
	display: flex;
	justify-content: space-evenly;
	align-items: center;
	flex-wrap: wrap;
}

.container__dashboard__contentbody__card {
	display: flex;
	flex-direction: column;
	margin-top: 1.5rem;
}

.container__dashboard__contentbody__card > hr {
	margin: 0 1rem;
}

@media screen and (min-width: 992px) {
	.container__dashboard__contentbody__card {
		flex-direction: row;
	}

	.container__dashboard__contentbody__card > hr {
		height: auto;
		margin: 1rem 0;
		display: inline-block;
		width: 0.1px;
	}
}

p {
	margin: 0;
}

table {
	max-width: 100%;
}
</style>
